<template>
  <!--START ABOUT US-->
  <section class="section bg-light scroll-select" id="features">
    <div class="container">
      <div class="row vertical-content">
        <div class="col-lg-5">
          <div class="features-box">
            <h3>Uma Startup que ajuda Startups a Startaparem</h3>
            <p class="text-muted web-desc">
              Startapeiros e Startapeiras, estamos aqui para oferecer o apoio
              necessário para que aquela sua ideia inovadora que salvará o mundo
              possa florescer da maneira que você merece!.
            </p>
            <ul class="text-muted list-unstyled margin-t-30 features-item-list">
              <li class="">
                Indicações para arrecadação de fundos e venture capital.
              </li>
              <li class="">
                Apoio na elaboração e refinamento do modelo de negócio.
              </li>
              <li class="">
                Recrutamento e seleção dos melhores talentos que te ajudarão
                nesta jornada.
              </li>
              <li class="">
                Ferramentas exclusivas de gestão, produtividade e tecnologia.
              </li>
            </ul>
            <a
              href="#"
              class="btn btn-custom margin-t-30 waves-effect waves-light"
              >Saiba Mais <i class="mdi mdi-arrow-right"></i
            ></a>
          </div>
        </div>
        <div class="col-lg-7">
          <div class="features-img features-right text-right">
            <img
              src="images/online-world.svg"
              alt="macbook image"
              class="img-fluid"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
  <!--END ABOUT US-->
</template>

<script>
export default {
  name: "About",
  props: {}
};
</script>
